import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { db } from './config';
import { logger } from '../utils/logger';

/**
 * Get user data from Firestore
 * @param {string} uid - User ID
 * @returns {Promise<object|null>} - User data or null
 */
export const getUserData = async (uid) => {
  try {
    const userDocRef = doc(db, 'users', uid);
    const userDoc = await getDoc(userDocRef);
    
    if (userDoc.exists()) {
      return userDoc.data();
    }
    return null;
  } catch (error) {
    logger.error('Error getting user data:', error);
    return null;
  }
};

/**
 * Update user data in Firestore
 * @param {string} uid - User ID
 * @param {object} updates - Data to update
 * @returns {Promise<object>} - Success status
 */
export const updateUserData = async (uid, updates) => {
  try {
    const userDocRef = doc(db, 'users', uid);
    await updateDoc(userDocRef, {
      ...updates,
      updatedAt: new Date().toISOString()
    });
    return { success: true };
  } catch (error) {
    logger.error('Error updating user data:', error);
    return {
      success: false,
      error: error.message || 'Failed to update user data'
    };
  }
};

/**
 * Update subscription data in Firestore
 * @param {string} uid - User ID
 * @param {object} subscriptionData - Subscription data to update
 * @returns {Promise<object>} - Success status
 */
export const updateSubscriptionData = async (uid, subscriptionData) => {
  try {
    const userDocRef = doc(db, 'users', uid);
    await updateDoc(userDocRef, {
      'subscription': subscriptionData,
      updatedAt: new Date().toISOString()
    });
    return { success: true };
  } catch (error) {
    logger.error('Error updating subscription data:', error);
    return {
      success: false,
      error: error.message || 'Failed to update subscription data'
    };
  }
};














